import axios from "axios";
import Swal from "sweetalert2";
import { baseUrl, defaultAddErrorMessage, errorTranslate } from "../util";
import { i18n } from "../../i18n";

// Helper function for sorting
const compare = (a, b) => {
  if (a.value < b.value) {
    return -1;
  }
  if (a.value > b.value) {
    return 1;
  }
  return 0;
};

export const getProductTravelList = ({
  productId,
  objectId,
  objects,
  setObjects,
}) => {
  var config = {
    method: "get",
    url: baseUrl + "/api/business/product/" + productId + "/travel",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  axios(config)
    .then(function (response) {
      setObjects(response.data.data);
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const addTravelToProduct = ({
  productId,
  method = "manual",
  name_of_journey,
  visiting_country,
  // Flow 14.1 fields
  currency,
  expenditures_hotel_restaurant,
  type_of_accommodation,
  means_transportation,
  expenditures_transportation,
  number_of_employees,
  // Flow 14.2 fields
  quantity_per_functional_unit,
  manuel,
  loading = null,
  setLoading = null,
  index,
  use_swal = false,
  callback = null,
  setErrorMessage = function () {
    return;
  },
}) => {
  var data = JSON.stringify({
    method: method,
    name_of_journey: name_of_journey || null,
    visiting_country: visiting_country,
    // Flow 14.1 fields
    currency: currency || null,
    expenditures_hotel_restaurant: expenditures_hotel_restaurant || null,
    type_of_accommodation: type_of_accommodation || null,
    means_transportation: means_transportation || null,
    expenditures_transportation: expenditures_transportation || null,
    number_of_employees: number_of_employees || null,
    // Flow 14.2 fields
    quantity_per_functional_unit: quantity_per_functional_unit || null,
    manuel: manuel || null,
  });

  var config = {
    method: "post",
    url: baseUrl + "/api/business/product/" + productId + "/travel",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
    data: data,
  };
  if (loading) setLoading("load");

  axios(config)
    .then(function (response) {
      if (use_swal) {
        Swal.fire({
          title: "Success!",
          icon: "success",
          confirmButtonColor: "#a9c1b4",
          color: "#476355",
          background: "#f1f8ef",
        });
      }
      if (loading) setLoading("success");
      if (callback) callback();
      setErrorMessage();
    })
    .catch(function (error) {
      console.log(error);
      if (loading) setLoading("failed");
      if (use_swal) {
        Swal.fire({
          title: errorTranslate(),
          icon: "error",
          text: defaultAddErrorMessage,
          confirmButtonColor: "#a9c1b4",
          color: "#476355",
          background: "#f1f8ef",
        });
        setErrorMessage(error.response.data);
      }
    });
};

export const getProductTravel = ({ id, setObjects, objects, componentId }) => {
  var config = {
    method: "get",
    url: baseUrl + "/api/business/product/" + id + "/travel/" + componentId,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  axios(config)
    .then(function (response) {
      setObjects(
        objects.map((component) => {
          if (component.id === componentId) {
            const newComponent = response.data.data;
            newComponent.identical_return = newComponent.identical_return
              ? "Yes"
              : "No";
            return newComponent;
          }
          return component;
        })
      );
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const updateProductTravel = ({
  productId,
  componentId,
  method = "manual",
  name_of_journey,
  visiting_country,
  // Flow 14.1 fields
  currency,
  expenditures_hotel_restaurant,
  type_of_accommodation,
  means_transportation,
  expenditures_transportation,
  number_of_employees,
  // Flow 14.2 fields
  quantity_per_functional_unit,
  manuel,
  objects,
  setObjects = function () {
    return;
  },
  use_swal = false,
  loading = null,
  setLoading = null,
  callback,
  setErrorMessage = function () {
    return;
  },
}) => {
  var data = JSON.stringify({
    method: method,
    name_of_journey: name_of_journey || null,
    visiting_country: visiting_country,
    // Flow 14.1 fields
    currency: currency || null,
    expenditures_hotel_restaurant: expenditures_hotel_restaurant || null,
    type_of_accommodation: type_of_accommodation || null,
    means_transportation: means_transportation || null,
    expenditures_transportation: expenditures_transportation || null,
    number_of_employees: number_of_employees || null,
    // Flow 14.2 fields
    quantity_per_functional_unit: quantity_per_functional_unit || null,
    manuel: manuel || null,
  });

  var config = {
    method: "put",
    url:
      baseUrl + "/api/business/product/" + productId + "/travel/" + componentId,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
    data: data,
  };

  if (loading) setLoading("load");

  axios(config)
    .then(function (response) {
      setObjects(
        objects.map((supply) => {
          if (response.data.data.id === supply.id) {
            return response.data.data;
          }
          return supply;
        })
      );
      if (use_swal)
        Swal.fire({
          title: "Success!",
          icon: "success",
          confirmButtonColor: "#a9c1b4",
          color: "#476355",
          background: "#f1f8ef",
        });
      if (loading) setLoading("success");
      if (callback) callback();
      setErrorMessage();
    })
    .catch(function (error) {
      console.log(error);
      if (loading) setLoading("failed");
      setErrorMessage(error.response.data);
    });
};

export const deleteProductTravel = ({
  productId,
  componentId,
  use_swal = false,
  loading = null,
  setLoading = null,
  callback,
}) => {
  var config = {
    method: "delete",
    url:
      baseUrl + "/api/business/product/" + productId + "/travel/" + componentId,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };
  if (loading) setLoading("load");

  axios(config)
    .then(function (response) {
      if (use_swal)
        Swal.fire({
          title: "Success!",
          icon: "success",
          // text: error,
          confirmButtonColor: "#a9c1b4",
          // width: 600,
          // padding: '3em',
          color: "#476355",
          background: "#f1f8ef",
        });
      if (loading) setLoading("success");
      if (callback) callback();
    })
    .catch(function (error) {
      console.log(error);
      if (loading) setLoading("failed");
      if (use_swal)
        Swal.fire({
          title: errorTranslate(),
          icon: "error",
          text: error,
          confirmButtonColor: "#a9c1b4",
          // width: 600,
          // padding: '3em',
          color: "#476355",
          background: "#f1f8ef",
        });
    });
};

export const getBusinessTravelCountryData = ({ setDropdown }) => {
  const config = {
    method: "get",
    url: baseUrl + "/api/business/business-travel-country-data",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  axios(config)
    .then(function (response) {
      setDropdown(
        response.data.data
          .map((country) => {
            country.value = country.name;
            country.id = country.name;
            return country;
          })
          .sort(compare)
      );
    })
    .catch(function (error) {
      console.log(error);
    });
};
